module.exports = __webpack_public_path__ + "static/media/sad.6180a27a.mp3";